import * as types from './ProductsTypes';

export default function ProductsReducer(state, action) {
    const { type, payload } = action;

    switch (type) {
        case types.GET_PRODUCTS_PRODUCTS:
            return {
                ...state,
                getProducts: {
                    ...state.getProducts,
                    products: payload.data,
                    loading: false,
                    hasSuccess: true,
                    hasError: {
                        code: null,
                        message: null
                    }
                },
            };
        case types.GET_PRODUCTS_PRODUCTS_LOADING:
            return {
                ...state,
                getProducts: {
                    ...state.getProducts,
                    loading: true
                },
            };
        case types.GET_PRODUCTS_PRODUCTS_ERROR:
            return {
                ...state,
                getProducts: {
                    ...state.getProducts,
                    loading: false,
                    hasSuccess: false,
                    hasError: {
                        code: payload.code,
                        message: payload.message
                    }
                },
            };
        case types.GET_PRODUCTS_TYPES:
            return {
                ...state,
                getProductsTypes: {
                    ...state.getProductsTypes,
                    productsTypes: payload.data,
                    loading: false,
                    hasSuccess: true,
                    hasError: {
                        code: null,
                        message: null
                    }
                },
            };
        case types.GET_PRODUCTS_TYPES_LOADING:
            return {
                ...state,
                getProductsTypes: {
                    ...state.getProductsTypes,
                    loading: true
                },
            };
        case types.GET_PRODUCTS_TYPES_ERROR:
            return {
                ...state,
                getProductsTypes: {
                    ...state.getProductsTypes,
                    loading: false,
                    hasSuccess: false,
                    hasError: {
                        code: payload.code,
                        message: payload.message
                    }
                },
            };
        case types.GET_CATEGORIES_PRODUCTS:
            return {
                ...state,
                getCategoriesProducts: {
                    ...state.getCategoriesProducts,
                    categoriesProducts: payload.data,
                    firstCategoryProduct: payload.first,
                    lastCategoryProduct: payload.last,
                    loading: false,
                    hasSuccess: true,
                    hasError: {
                        code: null,
                        message: null
                    }
                },
            };
        case types.GET_CATEGORIES_PRODUCTS_LOADING:
            return {
                ...state,
                getCategoriesProducts: {
                    ...state.getCategoriesProducts,
                    loading: true
                },
            };
        case types.GET_CATEGORIES_PRODUCTS_ERROR:
            return {
                ...state,
                getCategoriesProducts: {
                    ...state.getCategoriesProducts,
                    loading: false,
                    hasSuccess: false,
                    hasError: {
                        code: payload.code,
                        message: payload.message
                    }
                },
            };
            case types.GET_CATEGORIES_PRODUCTS_BY_ID:
                return {
                    ...state,
                    getCategoriesProductsById: {
                        ...state.getCategoriesProductsById,
                        categoryProduct: payload.data,
                        loading: false,
                        hasSuccess: true,
                        hasError: {
                            code: null,
                            message: null
                        }
                    },
                };
            case types.GET_CATEGORIES_PRODUCTS_BY_ID_LOADING:
                return {
                    ...state,
                    getCategoriesProductsById: {
                        ...state.getCategoriesProductsById,
                        loading: true
                    },
                };
            case types.GET_CATEGORIES_PRODUCTS_BY_ID_ERROR:
                return {
                    ...state,
                    getCategoriesProductsById: {
                        ...state.getCategoriesProductsById,
                        loading: false,
                        hasSuccess: false,
                        hasError: {
                            code: payload.code,
                            message: payload.message
                        }
                    },
                };
            case types.CREATE_CATEGORIES_PRODUCTS:
                return {
                    ...state,
                    createCategoriesProducts: {
                        ...state.createCategoriesProducts,
                        loading: false,
                        hasSuccess: true,
                        hasError: {
                            code: null,
                            message: null
                        },
                    },
                };
            case types.CREATE_CATEGORIES_PRODUCTS_LOADING:
                return {
                    ...state,
                    createCategoriesProducts: {
                        ...state.createCategoriesProducts,
                        loading: true
                    },
                };
            case types.CREATE_CATEGORIES_PRODUCTS_ERROR:
                return {
                    ...state,
                    createCategoriesProducts: {
                        ...state.createCategoriesProducts,
                        loading: false,
                        hasSuccess: false,
                        hasError: {
                            code: payload.code,
                            message: payload.message
                        },
                    },
                };
            case types.CREATE_CATEGORIES_PRODUCTS_RESET_STATE:
                return {
                    ...state,
                    createCategoriesProducts: {
                        ...state.createCategoriesProducts,
                        loading: false,
                        hasSuccess: false,
                        hasError: {
                            code: null,
                            message: null
                        }
                    },
                };
            case types.UPDATE_CATEGORIES_PRODUCTS_BY_ID:
                return {
                    ...state,
                    updateCategoriesProductsById: {
                        ...state.updateCategoriesProductsById,
                        loading: false,
                        hasSuccess: true,
                        hasError: {
                            code: null,
                            message: null
                        }
                    }
                };
            case types.UPDATE_CATEGORIES_PRODUCTS_BY_ID_LOADING:
                return {
                    ...state,
                    updateCategoriesProductsById: {
                        ...state.updateCategoriesProductsById,
                        loading: true,
                    }
                };
            case types.UPDATE_CATEGORIES_PRODUCTS_BY_ID_ERROR:
                return {
                    ...state,
                    updateCategoriesProductsById: {
                        ...state.updateCategoriesProductsById,
                        loading: false,
                        hasSuccess: false,
                        hasError: {
                            code: payload.code,
                            message: payload.message
                        }
                    }
                };
            case types.GET_SUBCATEGORIES_PRODUCTS_BY_ID:
                return {
                    ...state,
                    getSubCategoriesProductsById: {
                        ...state.getSubCategoriesProductsById,
                        subCategoriesProducts: payload.data,
                        loading: false,
                        hasSuccess: true,
                        hasError: {
                            code: null,
                            message: null
                        }
                    },
                };
            case types.GET_SUBCATEGORIES_PRODUCTS_BY_ID_LOADING:
                return {
                    ...state,
                    getSubCategoriesProductsById: {
                        ...state.getSubCategoriesProductsById,
                        loading: true
                    },
                };
            case types.GET_SUBCATEGORIES_PRODUCTS_BY_ID_ERROR:
                return {
                    ...state,
                    getSubCategoriesProductsById: {
                        ...state.getSubCategoriesProductsById,
                        loading: false,
                        hasSuccess: false,
                        hasError: {
                            code: payload.code,
                            message: payload.message
                        }
                    },
                }; 
            case types.CREATE_SUBCATEGORIES_PRODUCTS:
                return {
                    ...state,
                    createSubCategoriesProducts: {
                        ...state.createSubCategoriesProducts,
                        loading: false,
                        hasSuccess: true,
                        hasError: {
                            code: null,
                            message: null
                        },
                    },
                };
            case types.CREATE_SUBCATEGORIES_PRODUCTS_LOADING:
                return {
                    ...state,
                    createSubCategoriesProducts: {
                        ...state.createSubCategoriesProducts,
                        loading: true
                    },
                };
            case types.CREATE_SUBCATEGORIES_PRODUCTS_ERROR:
                return {
                    ...state,
                    createSubCategoriesProducts: {
                        ...state.createSubCategoriesProducts,
                        loading: false,
                        hasSuccess: false,
                        hasError: {
                            code: payload.code,
                            message: payload.message
                        },
                    },
                };
            case types.GET_PRODUCTS:
                return {
                    ...state,
                    getProducts: {
                        ...state.getProducts,
                        products: payload.data,
                        loading: false,
                        hasSuccess: true,
                        hasError: {
                            code: null,
                            message: null
                        },
                    },
                }
            case types.GET_PRODUCTS_LOADING:
                return {
                    ...state,
                    getProducts: {
                        ...state.getProducts,
                        loading: true
                    },
                }
            case types.GET_PRODUCTS_ERROR:
                return {
                    ...state,
                    getProducts: {
                        ...state.getProducts,
                        loading: false,
                        hasSuccess: false,
                        hasError: {
                            code: payload.code,
                            message: payload.message
                        },
                    },
                }
            case types.UPDATE_CATEGORIES_PRODUCTS_RESET_STATE:
                return {
                    ...state,
                    updateCategoriesProductsById: {
                        loading: false,
                        hasSuccess: false,
                        hasError: {
                            code: null,
                            message: null
                        }
                    },
                };
    
        default:
            return state;
    }
}